import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NonceService {
  private nonce: string;

  constructor() {
    this.generateNonce(); // Generate the nonce during initialization
  }

  private generateNonce() {

    //Random Generator
    // const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    // let result = '';
    // const charactersLength = characters.length;
    // for (let i = 0; i < 16; i++) {
    //   result += characters.charAt(Math.floor(Math.random() * charactersLength));
    // }
    // this.nonce = result;

    //Fixed Generator
    this.nonce = 'TUVWXYghi';
  }

  getNonce() {
    //return this.nonce;
    return 'TUVWXYghi';
  }
}